import _ from 'lodash';
import i18n from './reacti18n';
import { getEligibleFilters, isLoggedIn, getIsBusinessUser, getCountry } from './page';

const docTypeOptions = {
  faq: i18n.message('smarthelp/searchResult.searchResult.filter.docType.options.faq'),
  mts: i18n.message('smarthelp/searchResult.searchResult.filter.docType.options.mtsFaq'),
  brc: i18n.message('smarthelp/searchResult.searchResult.filter.docType.options.brc'),
  developer: i18n.message('smarthelp/searchResult.searchResult.filter.docType.options.dev'),
  product: i18n.message('smarthelp/searchResult.searchResult.filter.docType.options.mpp'),
};

/**
 * Return the Search Filter Form Field Objects as per given options.
 * @return {Array}               Array of Search Filter Form Field Objects.
 */
const getSearchFilter = () => {
  const fieldOptions = getEligibleFilters();
  const defaultOptions = ['faq'];

  const searchFilters = [{
    id: 'docType',
    type: 'radio',
    label: i18n.message('smarthelp/searchResult.searchResult.filter.docType.label'),
    isRequired: false,
    hasError: false,
    value: 'faq',
    options: [],
  }];

  let eligibleOptions = (fieldOptions.length > 0) ? fieldOptions : defaultOptions;

  // filter out mts for login US business user
  if (isLoggedIn() && getIsBusinessUser() && getCountry() === 'us') {
    eligibleOptions = _.filter(eligibleOptions, option => (option !== 'mts'));
  }
  searchFilters[0].options = eligibleOptions.map(value => ({
    label: docTypeOptions[value],
    value,
  }));

  return searchFilters;
};

const mobileFilter = {
  apply: i18n.message('smarthelp/searchResult.searchResult.mobile.filter.apply'),
};

const searchMobileButton = {
  id: 'mobileButton',
  type: 'button',
  submitLabel: mobileFilter.apply,
  resetLabel: '',
  hasCancelButton: false,
  submitButtonStyle: 'submit-button-container',
  handleCancel: () => {},
};

export default { docTypeOptions, getSearchFilter, searchMobileButton };



// WEBPACK FOOTER //
// ./lib/customFields.js